import React from "react";

export function PageHeader({ overline, title, description, actions }) {
  return (
    <div className="mb-8">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          {overline && <p className="label-overline text-gold mb-2">{overline}</p>}
          <h1 className="font-display text-4xl md:text-5xl tracking-tight">{title}</h1>
          {description && <p className="text-sm text-muted-foreground mt-2 max-w-2xl">{description}</p>}
        </div>
        {actions && <div className="flex items-center gap-2 flex-wrap">{actions}</div>}
      </div>
      <div className="gold-rule w-16 mt-4" />
    </div>
  );
}
